import type { RouteObject } from 'react-router';
import { TyreDetailPage } from './pages/TyreDetailPage';

export const TYRE_ROUTES: RouteObject[] = [{ path: 'maintenance/tyres/:id', element: <TyreDetailPage /> }];
